module.exports = __webpack_public_path__ + "static/media/Nornikel_main_preview.49dd0623.jpg";